import { create } from 'zustand'
import { immer } from "zustand/middleware/immer";

export const useHeaderStorage = create(immer(set => ({
    dados: {
        openAtendimentoSac: false
    },
    loaders: {},
    dispatch: {
        setOpenAtendimentoSac: (payload) => set(state => {
            state.dados.openAtendimentoSac = payload
        }), 
    }
})))